import React, { useCallback, useMemo } from "react";

import { couponTableColumnsConfig } from "./couponTableColumnDef";
import { Table } from "../../../component/table/Table";

import { useNavigate } from "react-router-dom";

export const CouponTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (cancellationId) => {
      navigate(`/coupons/${cancellationId}`);
    },
    [navigate]
  );

  const columnDefs = useMemo(
    () => couponTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );
  return <Table data={data} columns={columnDefs} />;
};
